<button *ngIf="user.canManage($safeNavigationMigration(contract?.tender))" [class]="class" (click)="openModal(editContractModal)">
  <span>Edit Contract Conditions</span>
</button>
<ng-template #editContractModal let-modal>
  <div class="modal-header bg-dark text-white">
    <h4 class="modal-title">Edit Contract Conditions</h4>
    <div class="ms-auto" data-bs-theme="dark">
      <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="modal.dismiss()">
    </button>
    </div>
  </div>
  <div class="modal-body">
    <p class="mb-3">What percentage of the total volume at this location should be tentatively awarded to<br><strong>{{this.offer.supplier.name}}<span *ngIf="this.offer.supplier.supplierAlias"> ({{this.offer.supplier.supplierAlias}})</span></strong>?</p>
    <form [formGroup]="form" novalidate>
      <div class="row">
        <div class="col-md-6">
          <label class="form-label">Award Percentage of Total Volume</label>
          <div class="input-group mb-3">
            <input type="text" class="form-control" formControlName="percent_awarded"
              [ngClass]="getFormGroupErrorClasses(form.controls.percent_awarded)" placeholder="35">
            <span class="input-group-text">%</span>
            <div class="invalid-feedback" *ngIf="showErrorBlock(form.controls.percent_awarded)">
              <span *ngIf="form.controls.percent_awarded.errors">Invalid percentage value entered.</span>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <label class="form-label">Award Contract Volume</label>
          <div class="input-group mb-3">
            <input type="text" class="form-control" formControlName="volume"
              [ngClass]="getFormGroupErrorClasses(form.controls.volume)" placeholder="33,180,640"
              (blur)="onVolumeBlur()">
            <span class="input-group-text">{{contract.units.code}}</span>
            <div class="invalid-feedback" *ngIf="showErrorBlock(form.controls.volume)">
              <span *ngIf="form.controls.volume.errors">Invalid volume value entered.</span>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-3">
        <label class="form-label">Contract Type</label>
        <select class="form-select" formControlName="award_self_supply">
          <option value="" selected>Fuel & Logistics</option>
          <option [value]="AWARD_SELF_SUPPLY_OPTIONS.FUEL_ONLY">Fuel only</option>
          <option [value]="AWARD_SELF_SUPPLY_OPTIONS.LOGISTICS">Logistics</option>
        </select>
      </div>

      <div class="mb-3">
        <label class="form-label">Contract Terms</label>
        <div class="row">
          <div class="col-md-6">
            <div class="input-group mb-2">
              <input (click)="d2.toggle()"
                [ngClass]="getFormGroupErrorClasses(form.controls.date_contract_start)" class="form-control datepicker"
                formControlName="date_contract_start" ngbDatepicker #d2="ngbDatepicker" placeholder="">
              <span class="input-group-text">Start Date</span>
              <div class="invalid-feedback" *ngIf="showErrorBlock(form.controls.date_contract_start)">
                <span *ngIf="form.controls.date_contract_start.errors">Invalid</span>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="input-group">
              <input (click)="d3.toggle()"
                [ngClass]="getFormGroupErrorClasses(form.controls.date_contract_end)" class="form-control datepicker"
                formControlName="date_contract_end" ngbDatepicker #d3="ngbDatepicker" placeholder="">
              <span class="input-group-text">End Date</span>
              <div class="invalid-feedback" *ngIf="showErrorBlock(form.controls.date_contract_end)">
                <span *ngIf="form.controls.date_contract_end.errors">Invalid</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary text-white" [disabled]="form.invalid" (click)="edit(offer, modal)">
      Edit Contract Conditions
    </button>
    <button type="button" class="btn btn-light" (click)="modal.dismiss()">
      Cancel
    </button>
  </div>
</ng-template>
